import { getCloudinaryThemeFileUrl } from '@/integrations/cloudinary/helpers'
import { TitleDecorationProps } from 'components/cms/TitleDecoration/TitleDecoration'

const TitleDecoration = ({ className = '' }: TitleDecorationProps) => {
  return (
    <>
      <div className={`root ${className}`} />
      <style jsx>
        {`
          .root {
            position: absolute;
            z-index: -1;
            left: 0;
            right: 0;
            padding: 0;
            background-image: url(${getCloudinaryThemeFileUrl('images/elements/divider.png')});
            height: 35px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
          }
        `}
      </style>
    </>
  )
}

export default TitleDecoration
